import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./TableLayout.module.css";

const itemsPerPage = 5;
const token = localStorage.getItem("token");
const userId = localStorage.getItem("userId");
const userRole = localStorage.getItem("role");

function DynamicTableLayout() {
  const [campaignData, setCampaignData] = useState([]);
  const [developerData, setDeveloperData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  // const [transactionData, setTransactionData] = useState([]);
  const navigate = useNavigate();

  const [pages, setPages] = useState({
    campaign: 1,
    developer: 1,
    project: 1,
    // transaction: 1,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [res1, res2, res3, res4] = await Promise.all([
          axios.get(
            "https://prod.toxboxai.com/api/campaign/getallcampaign",
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            "https://prod.toxboxai.com/api/developer/getalldevelopers",
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            "https://prod.toxboxai.com/api/project/getproject",
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          // axios.get("https://prod.toxboxai.com/api/campaign/getallcampaign", {
          //   headers: { Authorization: `Bearer ${token}` },
          // }),
        ]);

        setCampaignData(res1.data.data.campaigns);
        setDeveloperData(res2.data.data.developers);
        setProjectData(res3.data.data.projects);
        // setTransactionData(res4.data.data.campaigns);
      } catch (error) {
        console.error("API fetch error:", error);
      }
    };

    fetchData();
  }, []);

  const extractColumns = (data) => {
    const keys = new Set();
    data.forEach((item) => {
      Object.keys(item || {}).forEach((key) => keys.add(key));
    });
    return Array.from(keys).map((key) => ({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1),
    }));
  };

  const renderTable = (data, title, pageKey, allowedColumns = null) => {
    const currentPage = pages[pageKey] || 1;
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const columns = allowedColumns
      ? allowedColumns.map((key) => ({
        key,
        label: key.charAt(0).toUpperCase() + key.slice(1),
      }))
      : extractColumns(data);

    const paginatedData = data.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
      setPages((prev) => ({ ...prev, [pageKey]: newPage }));
    };

    return (
      <div className={styles.tableContainer}>
        <h2 className={styles.heading}>{title}</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.key === "projectId"
                      ? row.projectId?.projectname || "-"
                      : col.key === "createdBy"
                        ? row.createdBy?.email || "-"
                        : col.key === "assignedParticipants"
                          ? Array.isArray(row.assignedParticipants)
                            ? row.assignedParticipants.join(", ")
                            : "-"
                          : col.key === "creditAssignmentHistory" ||
                            col.key === "creditUsageHistory" ||
                            col.key === "sheetData"
                            ? Array.isArray(row[col.key])
                              ? `${row[col.key].length} items`
                              : "-"
                            : typeof row[col.key] === "object" &&
                              row[col.key] !== null
                              ? JSON.stringify(row[col.key])
                              : row[col.key] ?? "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div className={styles.pagination}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ◀
            </button>
            {Array.from({ length: totalPages }, (_, i) => {
              const pageNum = i + 1;
              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={currentPage === pageNum ? styles.activePage : ""}
                >
                  {pageNum}
                </button>
              );
            })}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              ▶
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {renderTable(
        campaignData,
        "Campaign Details",
        "campaign",
        [
          "campaignname",
          "type",
          "startDate",
          "endDate",
          "budget",
          "spend",
          "projectId",
          "creditBalance",
        ],
        campaignData,
        ["creditUsageHistory"]
      )}
      {renderTable(developerData, "Developer Info", "developer", [
        "name",
        "email",
        "phoneNumber",
        "Region",
        "Status",
      ])}
      {renderTable(projectData, "Project Details", "project", [
        "projectname",
        "type",
        "location",
        "units",
        "priceRange",
        "launchDate",
        "completionDate",
      ])}
      {/* {renderTable(transactionData, "Transaction Details", "transaction", [
        "creditBalance",
      ])} */}
    </>
  );
}

export default DynamicTableLayout;
